import React, { forwardRef, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Typography, Box, RfSwitch as Component } from '../../index'
import withTheme from '../styles/withTheme'

import './toggle.scss'

const Toggle = forwardRef(function Toggle(props, ref) {
	const {
		value: valueProps,
		firstLabel,
		secondLabel,
		valueFirst,
		valueSecond,
		onChange,
		...other
	} = props

	const {
		orientation = 'horizontal',
		disabled,
	} = other

	const [toggleValue, setToggleValue] = useState(null)

	useEffect(() => {
		setToggleValue(valueProps)
	}, [valueProps])

	const handelChange = () => {
		if (disabled) {
			return
		}
		const newValue = toggleValue === valueFirst ? valueSecond : valueFirst
		setToggleValue(newValue)
		onChange && onChange(newValue)
	}

	const toggleSwitch = () => {
		if (disabled) {
			return
		}
		const newValue = toggleValue === valueFirst ? valueSecond : valueFirst
		setToggleValue(newValue)
		onChange && onChange(newValue)
	}

	return (
		<div ref={ref}>
			{orientation === 'horizontal' ? (
				<div className="Vb-rf-toggle">
					<div>
						<Box paddingX={3}>
							<Typography
								variant="small"
								style={{ cursor: 'pointer' }}
								onClick={toggleSwitch}
								weight={valueFirst === toggleValue ? 'medium' : 'regular'}
							>
								{firstLabel}
							</Typography>
						</Box>
					</div>
					<div>
						<Component
							checked={toggleValue === valueFirst}
							onChange={handelChange}
							{...other}
						/>
					</div>
					<div>
						<Box paddingX={3}>
							<Typography
								variant="small"
								style={{ cursor: 'pointer' }}
								onClick={toggleSwitch}
								weight={valueSecond === toggleValue ? 'medium' : 'regular'}
							>
								{secondLabel}
							</Typography>
						</Box>
					</div>
				</div>
			) : (
				<div className="Vb-rf-toggle">
					<div>
						<Component
							checked={toggleValue === valueFirst}
							onChange={handelChange}
							{...other}
						/>
					</div>
					<div>
						<Box paddingX={3}>
							<Typography
								variant="small"
								style={{ cursor: 'pointer' }}
								onClick={toggleSwitch}
								weight={valueFirst === toggleValue ? 'medium' : 'regular'}
							>
								{firstLabel}
							</Typography>
						</Box>

						<Box paddingX={3}>
							<Typography
								variant="small"
								style={{ cursor: 'pointer' }}
								onClick={toggleSwitch}
								weight={valueSecond === toggleValue ? 'medium' : 'regular'}
							>
								{secondLabel}
							</Typography>
						</Box>
					</div>
				</div>
			)}
		</div>
	)
})

export default withTheme('toggle')(Toggle)

Toggle.propTypes = {
	/**
	* The value to associate with the Toggle when selected in a Label. 
	*/
	value: PropTypes.any,

	/**
	* Text assigned to the first label
	*/
	firstLabel: PropTypes.string,

	/**
	* Text assigned to the second label
	*/
	secondLabel: PropTypes.string,

	/**
	* Value compared to the value attribute
	*/
	valueFirst: PropTypes.any,

	/**
	* Value compared to the value attribute
	*/
	valueSecond: PropTypes.any,

	/**
	* extend the styles applied to the component
	*/
	className: PropTypes.string,

	/**
	* If `true`, the Toggle is disabled.
	* @default false
	*/
	disabled: PropTypes.bool,

	/**
	* Callback fired when the state is changed.
	*
	* @param {object} event The event source of the callback.
	* You can pull out the new value state by accessing `value` (any).
	*/
	onChange: PropTypes.func,

	/**
	* the type of component orientation.
	* @default 'horizontal'
	*/
	orientation: PropTypes.oneOf(['horizontal', 'vertical'])
}